// MMC || MAGIC || AEREOVIAGEM
var projeto = "sky"; // @inject-projeto
var producao = true; // @inject-producao
var usaPacote = true;
var usaBeto = false;
var USACIRCUITOS = false; // exclusivo pra Delivery
var usaCivitatis = false;
var usaCarro = false;
var usaTermometro = true;
var somenteLinkCartao = false;
var idioma = "pt"; // Padrão de idioma sempre pt. Somente BRASIL OPERADORA que não usa pt.
var usalinktarifario = false;
var usalinkblackfriday = "";
var usasomenteida = false;
var permiteAgenciaBuscarSomenteAereo = false;
var servicosObrigatorios = false;
var map_box_accesstoken: string = "pk.eyJ1IjoiZ2VuaXVzd3MiLCJhIjoiY204eGh6YTBwMDN1YjJzcGxxbG9hZ3I5ZCJ9.dmxe9te0ZBA92zhxQEzwtQ";
var usa_contrato = false;
var usa_pax_pagante = true;
var usa_noite_extra_pacote = false;
switch (projeto.toUpperCase()) {
  case "GENIUS":
    var logo = "/assets/logo/genius-logo.svg";
    var logoLight = "/assets/logo/genius-light-logo.svg";
    var favicon = "/assets/logo/AS-Genius.svg";
    var endereco = "Av. Brasil, 1345, 4º Andar - Centro, Foz do Iguaçu - PR <br> (45) 3521-8599";
    var frase = "We Are Genius";
    var frasehome = "E a tecnologia corre em nossas veias";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/genius/loginBackground.png";
    var slider = "/assets/images/genius/loginBackground.png";
    var sliderDesktop = "/assets/images/genius/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://back-genius.bbrez.dev") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://back-genius.bbrez.dev") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://back-genius.bbrez.dev") : (apihotel = "http://localhost:62672");
    map_box_accesstoken = "pk.eyJ1IjoiZ2VuaXVzd3MiLCJhIjoiY204eGh6YTBwMDN1YjJzcGxxbG9hZ3I5ZCJ9.dmxe9te0ZBA92zhxQEzwtQ";
    break;
  case "TRITRAVEL":
    var logo = "/assets/logo/tritravel.PNG";
    var logoLight = "/assets/logo/tritravel_branca.PNG";
    var favicon = "/assets/logo/tritravel_branca.PNG";
    var endereco = "Avenida Coronel Marcos Konder, 950, Sala 10, Centro, Itajaí – Santa Catarina";
    var frase = "TriTravel";
    var frasehome = "Ofereça uma viagem inesquecível aos seus clientes";
    var wwp = "https://wa.me/5547991381500";
    var insta = "https://www.instagram.com/tritravelbr/";
    var face = "https://www.facebook.com/tritravelbr";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/tritravel/loginbackground.png";
    var slider = "./assets/images/tritravel/slide-tritravel.png";
    var sliderDesktop = "./assets/images/tritravel/slide-tritravel.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://api.tritravel.com.br/") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://api.tritravel.com.br/") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://api.tritravel.com.br/") : (apihotel = "http://localhost:62672");
    break;
  case "MMC":
    usaBeto = true;
    var logo = "/assets/logo/logo-nova-colorida.svg";
    var logoLight = "/assets/logo/logo-branca-sem-borda.png";
    var favicon = "/assets/logo/favicon-mmc-light.svg";
    var endereco = "Rua Marechal Floriano Peixoto, 1455 - Centro, Foz do Iguaçu - PR, 85851-020 - PR - (45)3521-7508";
    var frase = "Descubra o Brasil";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "https://www.instagram.com/mmcturismo/";
    var face = "https://www.facebook.com/receptivommc";
    var portfolio = "https://produto.mmcturismo.com.br/site/";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/mmc/backgroundImage.jpeg";
    var slider = "/assets/images/mmc/cataratas-mmc-turismo-receptivo.jpg";
    var sliderDesktop = "/assets/images/mmc/cataratas-mmc-turismo-receptivo-desktop.jpg";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    var linktarifario = "https://paquetes.mmcturismo.com.br/";
    usalinktarifario = true;
    servicosObrigatorios = true;
    usaTermometro = false;
    producao ? (api = "https://api.mmcturismo.com") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://aereo.mmcturismo.com") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://hotel.mmcturismo.com") : (apihotel = "http://localhost:62672");
    usalinkblackfriday = "";
    map_box_accesstoken = "pk.eyJ1IjoiZ2VuaXVzd3MiLCJhIjoiY21jdXI1MTFoMDM3ejJrcHcxbjZvbzNzOSJ9.3lPZLtzQBMTR_U7aU4oSSw";
    usa_pax_pagante = false;
    usa_noite_extra_pacote = true;
    break;
  case "BRASIL":
    var logo = "/assets/logo/logo-brasil.png";
    var logoLight = "/assets/logo/logo-brasil.png";
    var favicon = "/assets/logo/logo-brasil.png";
    var endereco = "";
    var frase = "Brasil Operadora";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = false; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/brasil/loginBackground.webp";
    var slider = "./assets/images/brasil/slide.jpg";
    var sliderDesktop = "/assets/images/brasil/slide.jpg";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://apibrasil.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apibrasil.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apibrasil.geniusws.com.br") : (apihotel = "http://localhost:62672");
    usaPacote = true;
    idioma = "es";
    break;
  case "KANGAROO":
    var logo = "/assets/logo/logo-kangaroo.png";
    var logoLight = "/assets/logo/logo-kangaroo.png";
    var favicon = "/assets/logo/logo-kangaroo.png";
    var endereco = "";
    var frase = "Kangaroo Tours";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/kangaroo/backgroundImage.png";
    var slider = "./assets/images/kangaroo/slide.jpg";
    var sliderDesktop = "/assets/images/mmc/slide.jpg";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://apikangaroo.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apikangaroo.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apikangaroo.geniusws.com.br") : (apihotel = "http://localhost:62672");
    usaPacote = false;
    break;
  case "TNOPERADORA":
    var logo = "/assets/logo/logo-tnoperadora.png";
    var logoLight = "/assets/logo/logo-tnoperadora.png";
    var favicon = "/assets/logo/logo-tnoperadora.png";
    var endereco = "";
    var frase = "TN Operadora";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = false; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/tnoperadora/fundo_preto.png";
    var slider = "./assets/images/tnoperadora/fundo_preto.png";
    var sliderDesktop = "./assets/images/tnoperadora/fundo_preto.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://apitnoperadora.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apitnoperadora.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apitnoperadora.geniusws.com.br") : (apihotel = "http://localhost:62672");

    break;
  case "SKY":
    var logo = "/assets/logo/Logo Sky Line.png";
    var logoLight = "/assets/logo/Logo Sky Line.png";
    var favicon = "/assets/logo/Logo Sky Line.png";
    var endereco = "Avenida Getúlio Vargas 14 - Itaituba, PA";
    var frase = "Sky Line Operadora";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://wa.me/5593991242595";
    var insta = "https://www.instagram.com/skylineoperadoradeviagens/";
    var face = "https://www.facebook.com/skylineoperadora.com.br/";
    var portfolio = "";
    var tarifario = false; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/sky/Logo Sky Line.jpeg";
    var slider = "./assets/images/sky/slide-sky.jpg";
    var sliderDesktop = "./assets/images/sky/slide-sky.jpg";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    usasomenteida = true;
    permiteAgenciaBuscarSomenteAereo = true;
    usa_contrato = true;
    producao ? (api = "https://api.skylineoperadora.com.br") : (api = "http://localhost:62672/");
    producao ? (apiaereo = "https://api.skylineoperadora.com.br") : (apiaereo = "http://localhost:62672/");
    producao ? (apihotel = "https://api.skylineoperadora.com.br") : (apihotel = "http://localhost:62672/");

    break;
  case "DELIVERY":
    usaCivitatis = true; // lembrar de tirar
    var logo = "/assets/logo/logo_Delivery_Tour.jpeg";
    var logoLight = "/assets/logo/logo_Delivery_Tour.png";
    var favicon = "/assets/logo/logo_Delivery_Tour.png";
    var endereco = "R. Victorino Cardoso, 220, Edf. Centro Comercial Jardins Sala 03, Jardim Cambiri, Vitoria – Espirito Santo";
    var frase = "Delivery Tour Operadora";
    var frasehome = "Ofereça uma viagem inesquecível aos seus clientes";
    var wwp = "https://wa.me/5527999926333";
    var insta = "https://www.instagram.com/deliverytour/";
    var face = "https://www.facebook.com/DeliveryTour";
    var portfolio = "";
    USACIRCUITOS = true;
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/deliverytour/logo-deliverytour.jpeg";
    var slider = "./assets/images/deliverytour/slide-deliverytour.jpg";
    var sliderDesktop = "./assets/images/deliverytour/slide-deliverytour.jpg";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://apideliverytour.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apideliverytour.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apideliverytour.geniusws.com.br") : (apihotel = "http://localhost:62672");
    // producao ? (api = "https://apideliverytour.geniusws.com.br") : (api = "https://apihomologa.geniusws.com.br");
    // producao ? (apiaereo = "https://apideliverytour.geniusws.com.br") : (apiaereo = "https://apihomologa.geniusws.com.br");
    // producao ? (apihotel = "https://apideliverytour.geniusws.com.br") : (apihotel = "https://apihomologa.geniusws.com.br");

    break;
  case "MEUCLUBE":
    var logo = "/assets/logo/logo_meuclube.png";
    var logoLight = "/assets/logo/logo-branca-meuclube.png";
    var favicon = "/assets/logo/logo-branca-meuclube.png";
    var endereco = "Alameda Santos, 647 – 6º andar Cerqueira César, São Paulo/SP – CEP: 01419-001";
    var frase = "Meu Clube de Viagens";
    var frasehome = "A plataforma de benefícios de viagens com ofertas exclusivas para os seus colaboradores";
    var wwp = "https://wa.me/5561999062580";
    var insta = "";
    var face = "";
    var portfolio = "";
    USACIRCUITOS = false;
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/meuclube/loginBackground.png";
    var slider = "./assets/images/meuclube/slide.png";
    var sliderDesktop = "./assets/images/meuclube/slide.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://apimeuclubedeviagens.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apimeuclubedeviagens.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apimeuclubedeviagens.geniusws.com.br") : (apihotel = "http://localhost:62672");

    break;
  case "USETRAVEL":
    var logo = "/assets/logo/logo-usetravel.svg";
    var logoLight = "/assets/logo/logo-usetravel.svg";
    var favicon = "/assets/logo/logo-usetravel.svg";
    var endereco = "Rua Quinze de Novembro, 1608, Casa 28, Vila Dubus, Presidente Prudente, São Paulo";
    var frase = "Use Travel";
    var frasehome = "Juntos para criar experiências inesquecíveis.";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = false; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/usetravel/logo-usetravel.png";
    var slider = "./assets/images/usetravel/slideuse.png";
    var sliderDesktop = "./assets/images/usetravel/slideuse.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    map_box_accesstoken = "pk.eyJ1IjoiZ2VuaXVzd3MiLCJhIjoiY21hNnMzM3JtMHVucjJrcG95MHhzZmNmMyJ9.N21xTMxmbbaOMjnIEsDWig";
    producao ? (api = "https://apiusetravel.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apiusetravel.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apiusetravel.geniusws.com.br") : (apihotel = "http://localhost:62672");
    usaPacote = false;
    break;
  case "BRAZILCONNECTION":
    var logo = "./assets/logo/logo-brazilconnection.png";
    var logoLight = "./assets/logo/logo-brazilconnection.png";
    var favicon = "./assets/logo/logo-brazilconnection.png";
    var endereco = "";
    var frase = "Brazil Connection";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5521982882369";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/brazilconnection/loginBackground.png";
    var slider = "./assets/images/brazilconnection/slide.png";
    var sliderDesktop = "./assets/images/brazilconnection/slide.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://api.brazilconnection.tur.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://api.brazilconnection.tur.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://api.brazilconnection.tur.br") : (apihotel = "http://localhost:62672");
    usaPacote = false;
    break;
  case "AEREOVIAGEM":
    var logo = "/assets/logo/logotipo-aereo-viagem-v002.png";
    var logoLight = "/assets/logo/logotipo-aereo-viagem-v002-negativo.png";
    var favicon = "/assets/logo/logotipo-aereo-viagem-v002-negativo.png";
    var endereco = "";
    var frase = "Aéreo Viagem";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/point/loginBackground.png";
    var slider = "./assets/images/point/loginBackground.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    producao ? (api = "https://api.agente.tur.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://aereo.agente.tur.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://hotel.agente.tur.br") : (apihotel = "http://localhost:62672");
    somenteLinkCartao = true;
    break;
  case "MAGIC":
    var logo = "../../../assets/logo/Magic-Way-Tours.png";
    var logoLight = "../../../assets/logo/magicway-branca.png";
    var favicon = "../../../assets/logo/magicway-branca-menor.png";
    var endereco = "Avenida Iguaçu, 2636 <br>Água Verde. Curitiba. CEP: 80240-030";
    var frase = "Embarque nessa com a gente!";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "https://magicway.com.br/";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/magic/backgroundImagemagic.jpg";
    var slider = "../../../assets/images/magic/fd-magic.png";
    var api = "";
    var apiaereo = "";
    var apihotel = "";
    var linktarifario = "";
    producao ? (api = "https://apimagicway.geniusws.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://apimagicway.geniusws.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://apimagicway.geniusws.com.br") : (apihotel = "http://localhost:62672");
    break;
  case "ARK":
    var logo = "/assets/logo/genius-logo.svg";
    var logoLight = "/assets/logo/genius-light-logo.svg";
    var favicon = "/assets/logo/AS-Genius.svg";
    var endereco = "Av. Brasil, 1345, 4º Andar - Centro, Foz do Iguaçu - PR <br> (45) 3521-8599";
    var frase = "We Are Genius";
    var frasehome = "E a tecnologia corre em nossas veias";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/genius/loginBackground.png";
    var slider = "/assets/images/genius/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://api.ark.tur.br") : (api = "http://localhost:62672");
    break;
  case "POINT":
    var logo = "/assets/logo/point-logo.png";
    var logoLight = "/assets/logo/point-light-logo.png";
    var favicon = "/assets/logo/AS-point.ico";
    var endereco = "Tv. Cristiano Weirich, 91 - Sala 3 - Centro, Foz do Iguaçu - PR, 85851-140<br> (45) 3523-0007";
    var frase = "POINT TUR ";
    var frasehome = "Viajar com a POINT TUR é colecionar momentos de toda uma vida!";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/point/loginBackground.png";
    var slider = "/assets/images/point/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://api.pointtur.com.br") : (api = "http://localhost:62672");
    producao ? (apiaereo = "https://api.pointtur.com.br") : (apiaereo = "http://localhost:62672");
    producao ? (apihotel = "https://api.pointtur.com.br") : (apihotel = "http://localhost:62672");

    break;
  case "OIKOS":
    var logo = "/assets/logo/oikos-logo.png";
    var logoLight = "/assets/logo/oikos-logo-light.png";
    var favicon = "/assets/logo/oikos-logo-light.png";
    var endereco = "R. Ouro Fino, 395 – Sala 702 – Cruzeiro, Belo Horizonte – MG, 30310-110<br>  (31) 3283-5777/(31) 9614-9354";
    var frase = "Oikos Travel";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://api.whatsapp.com/send?phone=553196149354";
    var insta = "https://www.instagram.com/oikostravel/";
    var face = "https://www.facebook.com/oikostravelbh";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/oikos/loginBackground.png";
    var slider = "/assets/images/oikos/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apioikos.geniusws.com.br") : (api = "http://localhost:62672");

    break;
  case "ALLTOUR":
    var logo = "/assets/logo/logo-alltour.png";
    var logoLight = "/assets/logo/logo_alltour_branco.png";
    var favicon = "/assets/logo/logo_alltour_branco.png";
    var endereco = "";
    var frase = "Alltour";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5571982666068";
    var insta = "https://www.instagram.com/alltourgroup/";
    var face = "https://www.facebook.com/AlltourBA";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apialltour.comprefacil.tur.br") : (api = "http://localhost:62672");

    break;
  case "ANAUE":
    var logo = "/assets/logo/logo-anaue.png";
    var logoLight = "/assets/logo/logo-anaue-branco.png";
    var favicon = "/assets/logo/logo-anaue-branco.png";
    var endereco = "";
    var frase = "Anauê";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5584991492484";
    var insta = "https://www.instagram.com/anauereceptivo/";
    var face = "https://www.facebook.com/AnaueReceptivo";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apianaue.comprefacil.tur.br") : (api = "http://localhost:62672");

    break;
  case "BROCKER":
    var logo = "/assets/logo/logo-brocker.png";
    var logoLight = "/assets/logo/logo-brocker.png";
    var favicon = "/assets/logo/logo-brocker.png";
    var endereco = "";
    var frase = "Brocker Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5554981707339";
    var insta = "https://www.instagram.com/brockerturismo/";
    var face = "https://www.facebook.com/brocker.turismo";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apibrocker.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "LUCK":
    var logo = "/assets/logo/logo-luck.png";
    var logoLight = "/assets/logo/logo-luck.png";
    var favicon = "/assets/logo/logo-luck.png";
    var endereco = "";
    var frase = "Luck Receptivo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5582991279524";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apiluck.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "MARTUR":
    var logo = "/assets/logo/logo-martur.png";
    var logoLight = "/assets/logo/logo-martur.png";
    var favicon = "/assets/logo/logo-martur.png";
    var endereco = "";
    var frase = "Martur Viagens e Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5581991639375";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apimartur.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "NETTOUR":
    var logo = "/assets/logo/logo-nettour.png";
    var logoLight = "/assets/logo/logo-nettour.png";
    var favicon = "/assets/logo/logo-nettour.png";
    var endereco = "";
    var frase = "Nettour Viagens e Receptivo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5585999314423";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apinettour.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "TAIPE":
    var logo = "/assets/logo/logo-taipe.png";
    var logoLight = "/assets/logo/logo-taipe.png";
    var favicon = "/assets/logo/logo-taipe.png";
    var endereco = "";
    var frase = "Taipe Viagens e Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5573988020339";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apitaipe.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "BONITOWAY":
    var logo = "/assets/logo/logo-bonitoway.png";
    var logoLight = "/assets/logo/logo-bonitoway.png";
    var favicon = "/assets/logo/logo-bonitoway.png";
    var endereco = "";
    var frase = "Bonito Way Agência de Viagem";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5567984691186";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apibonitoway.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "LUCKJPA":
    var logo = "/assets/logo/logo-luck.png";
    var logoLight = "/assets/logo/logo-luck.png";
    var favicon = "/assets/logo/logo-luck.png";
    var endereco = "";
    var frase = "Luck Receptivo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5583987459949";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apiluckjpa.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "COSTAAZUL":
    var logo = "/assets/logo/logo-costaazul.png";
    var logoLight = "/assets/logo/logo-costaazul.png";
    var favicon = "/assets/logo/logo-costaazul.png";
    var endereco = "";
    var frase = "CostaAzul";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5582991378394";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apicostaazul.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "INTERTOURING":
    var logo = "/assets/logo/logo-intertouring.png";
    var logoLight = "/assets/logo/logo-intertouring.png";
    var favicon = "/assets/logo/logo-intertouring.png";
    var endereco = "";
    var frase = "Intertouring Receptivo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5521976411306";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apiintertouring.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "URBEN":
    var logo = "/assets/logo/logo-urben.png";
    var logoLight = "/assets/logo/logo-urben.png";
    var favicon = "/assets/logo/logo-urben.png";
    var endereco = "";
    var frase = "Urben Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5511991956692";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apiurben.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "VIPMAR":
    var logo = "/assets/logo/logo-vipmar.png";
    var logoLight = "/assets/logo/logo-vipmar.png";
    var favicon = "/assets/logo/logo-vipmar.png";
    var endereco = "";
    var frase = "Vipmar";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5547999750594";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "/assets/images/alltour/loginBackground.png";
    var slider = "/assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://apivipmar.ark.tur.br") : (api = "http://localhost:62672");

    break;
  case "CAPIXABA":
    var logo = "./assets/logo/logo-capixaba.png";
    var logoLight = "./assets/logo/logo-capixaba.png";
    var favicon = "./assets/logo/logo-capixaba.png";
    var endereco = "";
    var frase = "Capixaba";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5527996063500";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/capixaba/api") : (api = "http://localhost:62672");

    break;
  case "PRESTHEZA":
    var logo = "./assets/logo/logo-prestheza.png";
    var logoLight = "./assets/logo/logo-prestheza.png";
    var favicon = "./assets/logo/logo-prestheza.png";
    var endereco = "";
    var frase = "Prestheza";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5561981163786";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/prestheza/api") : (api = "http://localhost:62672");

    break;
  case "INBUZIOS":
    var logo = "./assets/logo/logo-inbuzios.png";
    var logoLight = "./assets/logo/logo-inbuzios.png";
    var favicon = "./assets/logo/logo-inbuzios.png";
    var endereco = "";
    var frase = "Inbuzios";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5522974047531";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/inbuzios/api") : (api = "http://localhost:62672");

    break;
  case "TRILHASDEMINAS":
    var logo = "./assets/logo/logo-trilhasdeminas.png";
    var logoLight = "./assets/logo/logo-trilhasdeminas.png";
    var favicon = "./assets/logo/logo-trilhasdeminas.png";
    var endereco = "";
    var frase = "Trilhas De Minas";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5531987441601";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/trilhasdeminas/api") : (api = "http://localhost:62672");

    break;
  case "IMPACTOTOUR":
    var logo = "./assets/logo/logo-impactotour.png";
    var logoLight = "./assets/logo/logo-impactotour.png";
    var favicon = "./assets/logo/logo-impactotour.png";
    var endereco = "";
    var frase = "Impacto Tour";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5567992062282";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/impactotour/api") : (api = "http://localhost:62672");

    break;
  case "SERRAVERDE":
    var logo = "./assets/logo/logo-serraverde.png";
    var logoLight = "./assets/logo/logo-serraverde.png";
    var favicon = "./assets/logo/logo-serraverde.png";
    var endereco = "";
    var frase = "Serra Verde Express";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5567992062282";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/serraverde/api") : (api = "http://localhost:62672");

    break;
  case "ATALAIA":
    var logo = "./assets/logo/logo-atalaia.png";
    var logoLight = "./assets/logo/logo-atalaia.png";
    var favicon = "./assets/logo/logo-atalaia.png";
    var endereco = "";
    var frase = "Atalaia";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5581999797232";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/atalaia/api") : (api = "http://localhost:62672");

    break;
  case "GEKOS":
    var logo = "./assets/logo/logo-gekos.png";
    var logoLight = "./assets/logo/logo-gekos.png";
    var favicon = "./assets/logo/logo-gekos.png";
    var endereco = "";
    var frase = "Gekos";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5598981190456";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/gekos/api") : (api = "http://localhost:62672");

    break;
  case "TAGUATUR":
    var logo = "./assets/logo/logo-taguatur.png";
    var logoLight = "./assets/logo/logo-taguatur.png";
    var favicon = "./assets/logo/logo-taguatur.png";
    var endereco = "";
    var frase = "Taguatur";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5598981265666";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/taguatur/api") : (api = "http://localhost:62672");

    break;
  case "GIORDANI":
    var logo = "./assets/logo/logo-giordani.png";
    var logoLight = "./assets/logo/logo-giordani.png";
    var favicon = "./assets/logo/logo-giordani.png";
    var endereco = "";
    var frase = "Giordani Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5554999303897";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/giordani/api") : (api = "http://localhost:62672");

    break;
  case "LUCKSALVADOR":
    var logo = "./assets/logo/logo-luck.png";
    var logoLight = "./assets/logo/logo-luck.png";
    var favicon = "./assets/logo/logo-luck.png";
    var endereco = "";
    var frase = "Luck Receptivo - Salvador";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=558391213440";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/lucksalvador/api") : (api = "http://localhost:62672");

    break;
  case "LUCKRECIFE":
    var logo = "./assets/logo/logo-luck.png";
    var logoLight = "./assets/logo/logo-luck.png";
    var favicon = "./assets/logo/logo-luck.png";
    var endereco = "";
    var frase = "Luck Receptivo - Recife";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=558133666262";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/luckrecife/api") : (api = "http://localhost:62672");

    break;
  case "TACK":
    var logo = "./assets/logo/logo-tack.jpg";
    var logoLight = "./assets/logo/logo-tack.jpg";
    var favicon = "./assets/logo/logo-tack.jpg";
    var endereco = "";
    var frase = "Tack Turismo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "https://web.whatsapp.com/send?phone=5511945297878";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/tack/api") : (api = "http://localhost:62672");

    break;
  case "QUALITY":
    var logo = "./assets/logo/logo-quality.png";
    var logoLight = "./assets/logo/logo-quality.png";
    var favicon = "./assets/logo/logo-quality.png";
    var endereco = "";
    var frase = "Quality Travel";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    var linktarifario = "";
    producao ? (api = "https://ark.tur.br/quality/api") : (api = "http://localhost:62672");

    break;
  case "AEXTOUR":
    var logo = "./assets/logo/logo-aextour.png";
    var logoLight = "./assets/logo/logo-aextour.png";
    var favicon = "./assets/logo/logo-aextour.png";
    var endereco = "";
    var frase = "Aex Tour";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/aextour/api") : (api = "http://localhost:62672");

    break;
  case "ATTRAVEL":
    var logo = "./assets/logo/logo-attravel.png";
    var logoLight = "./assets/logo/logo-attravel.png";
    var favicon = "./assets/logo/logo-attravel.png";
    var endereco = "";
    var frase = "attravel";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/attravel/api") : (api = "http://localhost:62672");

    break;
  case "4HATS":
    var logo = "./assets/logo/logo-4hats.png";
    var logoLight = "./assets/logo/logo-4hats.png";
    var favicon = "./assets/logo/logo-4hats.png";
    var endereco = "";
    var frase = "4 Hats";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/4hats/api") : (api = "http://localhost:62672");

    break;
  case "NITESTRAVEL":
    var logo = "./assets/logo/logo-nitestravel.png";
    var logoLight = "./assets/logo/logo-nitestravel.png";
    var favicon = "./assets/logo/logo-nitestravel.png";
    var endereco = "";
    var frase = "nites travel";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/nitestravel/api") : (api = "http://localhost:62672");

    break;
  case "GOLFINHOTOUR":
    var logo = "./assets/logo/logo-golfinhotour.png";
    var logoLight = "./assets/logo/golfinhotour.png";
    var favicon = "./assets/logo/golfinhotour.png";
    var endereco = "";
    var frase = "Golfinho Tour";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://apigolfinhotour.geniusws.com.br") : (api = "http://localhost:62672");

    break;
  case "PTA":
    var logo = "./assets/logo/logo-pta.png";
    var logoLight = "./assets/logo/logo-pta.png";
    var favicon = "./assets/logo/logo-pta.png";
    var endereco = "";
    var frase = "PTA";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/pta/api") : (api = "http://localhost:62672");

    break;
  case "AMDRIVER":
    var logo = "./assets/logo/logo-amdriver.png";
    var logoLight = "./assets/logo/logo-amdriver.png";
    var favicon = "./assets/logo/logo-amdriver.png";
    var endereco = "";
    var frase = "AM DRIVER PREMIUM";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/amdriver/api") : (api = "http://localhost:62672");

    break;
  case "AEXTOUR":
    var logo = "./assets/logo/logo-aextour.png";
    var logoLight = "./assets/logo/logo-aextour.png";
    var favicon = "./assets/logo/logo-aextour.png";
    var endereco = "";
    var frase = "AEXTOUR";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/aextour/api") : (api = "http://localhost:62672");

    break;
  case "5STAR":
    var logo = "./assets/logo/logo-5star.png";
    var logoLight = "./assets/logo/logo-5star.png";
    var favicon = "./assets/logo/logo-5star.png";
    var endereco = "";
    var frase = "5STAR";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/5star/api") : (api = "http://localhost:62672");

    break;
  case "OTIUM":
    var logo = "./assets/logo/logo-otium.png";
    var logoLight = "./assets/logo/logo-otium.png";
    var favicon = "./assets/logo/logo-otium.png";
    var endereco = "";
    var frase = "Otium";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/otium/api") : (api = "http://localhost:62672");

    break;
  case "DCOM":
    var logo = "./assets/logo/logo-dcom.png";
    var logoLight = "./assets/logo/logo-dcom.png";
    var favicon = "./assets/logo/logo-dcom.png";
    var endereco = "";
    var frase = "DCOM";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/dcom/api") : (api = "http://localhost:62672");

    break;
  case "DISTINTOS":
    var logo = "./assets/logo/logo-distintos.png";
    var logoLight = "./assets/logo/logo-distintos.png";
    var favicon = "./assets/logo/logo-distintos.png";
    var endereco = "";
    var frase = "DISTINTOS";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/distintos/api") : (api = "http://localhost:62672");

    break;
  case "PESANTEZ":
    var logo = "./assets/logo/logo-pesantez.png";
    var logoLight = "./assets/logo/logo-pesantez.png";
    var favicon = "./assets/logo/logo-pesantez.png";
    var endereco = "";
    var frase = "PESANTEZ";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/pesantez/api") : (api = "http://localhost:62672");

    break;
  case "JULIATRAVEL":
    var logo = "./assets/logo/logo-juliatravel.png";
    var logoLight = "./assets/logo/logo-juliatravel.png";
    var favicon = "./assets/logo/logo-juliatravel.png";
    var endereco = "";
    var frase = "JULIA TRAVEL";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/juliatravel/api") : (api = "http://localhost:62672");

    break;
  case "LUP":
    var logo = "./assets/logo/logo-lup.png";
    var logoLight = "./assets/logo/logo-lup.png";
    var favicon = "./assets/logo/logo-lup.png";
    var endereco = "";
    var frase = "LUP BEACH VCLUB";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/lup/api") : (api = "http://localhost:62672");

    break;
  case "LIVINGTOURS":
    var logo = "./assets/logo/logo-livingtours.png";
    var logoLight = "./assets/logo/logo-livingtours.png";
    var favicon = "./assets/logo/logo-livingtours.png";
    var endereco = "";
    var frase = "LIVING TOURS";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/livingtours/api") : (api = "http://localhost:62672");

    break;
  case "EUROWELCOME":
    var logo = "./assets/logo/logo-eurowelcome.png";
    var logoLight = "./assets/logo/logo-eurowelcome.png";
    var favicon = "./assets/logo/logo-eurowelcome.png";
    var endereco = "";
    var frase = "EUROWELCOME";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/eurowelcome/api") : (api = "http://localhost:62672");

    break;
  case "MCA":
    var logo = "./assets/logo/logo-mca.png";
    var logoLight = "./assets/logo/logo-mca.png";
    var favicon = "./assets/logo/logo-mca.png";
    var endereco = "";
    var frase = "MCA";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/mca/api") : (api = "http://localhost:62672");

    break;
  case "SANTAEBELLA":
    var logo = "./assets/logo/logo-santaebella.png";
    var logoLight = "./assets/logo/logo-santaebella.png";
    var favicon = "./assets/logo/logo-santaebella.png";
    var endereco = "";
    var frase = "SANTA E BELLA";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/santaebella/api") : (api = "http://localhost:62672");

    break;
  case "GOCITY":
    var logo = "./assets/logo/logo-gocity.png";
    var logoLight = "./assets/logo/logo-gocity.png";
    var favicon = "./assets/logo/logo-gocity.png";
    var endereco = "";
    var frase = "GO CITY";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/gocity/api") : (api = "http://localhost:62672");

    break;
  case "SELECTA":
    var logo = "./assets/logo/logo-selecta.png";
    var logoLight = "./assets/logo/logo-selecta.png";
    var favicon = "./assets/logo/logo-selecta.png";
    var endereco = "";
    var frase = "SELECTA";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/selecta/api") : (api = "http://localhost:62672");

    break;
  case "ELEVATE":
    var logo = "./assets/logo/logo-elevate.png";
    var logoLight = "./assets/logo/logo-elevate.png";
    var favicon = "./assets/logo/logo-elevate.png";
    var endereco = "";
    var frase = "Elevate";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/elevate/api") : (api = "http://localhost:62672");
    break;
  case "EKATOURS":
    var logo = "./assets/logo/logo-ekatours.png";
    var logoLight = "./assets/logo/logo-ekatours.png";
    var favicon = "./assets/logo/logo-ekatours.png";
    var endereco = "";
    var frase = "Ekatours";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/ekatours/api") : (api = "http://localhost:62672");
    break;
  case "ALLREPS":
    var logo = "./assets/logo/logo-allreps.png";
    var logoLight = "./assets/logo/logo-allreps.png";
    var favicon = "./assets/logo/logo-allreps.png";
    var endereco = "";
    var frase = "AllReps Receptivo";
    var frasehome = "Ofereça uma viagem inesquecível aos seus PAX";
    var wwp = "";
    var insta = "";
    var face = "";
    var portfolio = "";
    var tarifario = true; //esconde ou mostra o item de tarifario do menu
    var background = "./assets/images/alltour/loginBackground.png";
    var slider = "./assets/images/alltour/loginBackground.png";
    var api = "";
    producao ? (api = "https://ark.tur.br/allreps/api") : (api = "http://localhost:62672");
    break;
}

export const USA_AEREO = true;
export const USA_LINKTARIFARIO = usalinktarifario; //Exclusivo MMC
export const USA_PACOTE = usaPacote; //Exclusivo MMC
export const USA_BETO = usaBeto; //Exclusivo MMC
export const USA_LAMINAS = false;
export const USA_CARRO = usaCarro; // Exclusivo MMC
export const USA_CIVITATIS = usaCivitatis; // Exclusivo MMC e DELIVERY
export const SERVICOS_OBRIGATORIOS = servicosObrigatorios; // true para MMC - traz os serviços vinculados ao pacote como obrigatório
//Permite apenas link de pagamento;
export const SOMENTE_LINK_PAGAMENTO = somenteLinkCartao;
export const PROJETO = projeto;
export const API = api;
export const LOGO = logo;
export const LOGOLIGHT = logoLight;
export const FAVICONLIGHT = favicon;
export const ENDERECOTELEFONE = endereco;
export const FRASELOGIN = frase;
export const FRASEHOME = frasehome;
export const WPP = wwp;
export const INSTAGRAM = insta;
export const FACEBOOK = face;
export const LINKPORTFOLIO = portfolio;
export const IDIOMA = idioma;
export const LINKTARIFARIO = linktarifario;
export const ESCONDERTARIFARIO = tarifario;
export const LINKBLACKFRIDAY = usalinkblackfriday;
export const BACKGROUNDIMAGE = background;
export const SLIDERHOME = slider;
export const SLIDERHOMEDESKTOP = sliderDesktop;
export const CLIENT_ID = "postman:123";
export const ITENSPORPAGINA = 20;
export const PACOTESPORPAGINA = 9;
export const ITENSORCAMENTO = 20;
export const EMPRESAS = API;
export const GERENCIAMENTO = API;
export const TURISMO = API;
export const TURISMO_AEREO = apiaereo;
export const TURISMO_HOTEL = apihotel;
export const TURISMO_TICKET = API;
export const TURISMO_TRANSFER = API;
export const TURISMO_SEGURO = API;
export const TURISMO_CARRO = API;
export const USASOMENTEIDA = usasomenteida;
export const PERMITEAGENCIABUSCARSOMENTEAEREO = permiteAgenciaBuscarSomenteAereo;
export const USA_CIRCUITOS = USACIRCUITOS;
export const MAPBOX_ACCESSTOKEN = map_box_accesstoken;
export const USA_CONTRATO = usa_contrato;
export const USA_TERMOMETRO = usaTermometro;
export const USA_PAXPAGANTE = usa_pax_pagante;
export const USA_NOITE_EXTRA_PACOTE = usa_noite_extra_pacote;